import React from 'react';
import { FormLabelUI, SelectUI } from '../Interface';
import { sxConfig } from './kanban.style';

const ViewSelectField = ({ filteredViewType, type, setType, saveView, navigate, subMenuName }) => {
  return (
    <div className="w-[110px]">
      <SelectUI
        label={<FormLabelUI text="Nézet" textColor="xl:text-white" />}
        option={filteredViewType}
        value={type}
        onChange={(e) => {
          const value = e.target.value;

          setType(value);
          saveView('kanbanFilter', { viewType: value });

          if (subMenuName) {
            navigate('/app/taskkanban', { replace: true });
          }
        }}
        sx={{
          '@media (min-width:1140px)': {
            ...sxConfig.fieldColor,
          },
        }}
      />
    </div>
  );
};

export default ViewSelectField;
